@for (item of links(); track $index) {
  <ideal-file-button [url]="item.url" [label]="item.label" />
}
